import React from 'react';
import { Card, CardContent } from './ui/card';
import { Building2, Car, Mountain, Building } from 'lucide-react';

export const IndustriesServed = () => {
  const industries = [
    {
      icon: Building2,
      title: 'Civil Infrastructure',
      description: 'Expertise in bridges, highways, and public works projects across South Africa requiring structural precision and long-term durability.',
      projects: 'Specialist Capability',
      color: 'text-primary'
    },
    {
      icon: Car,
      title: 'Automotive & Transport',
      description: 'Advanced knowledge in high-performance fabrication for automotive manufacturing, rail systems, and transportation infrastructure throughout Gauteng.',
      projects: 'Industry Expertise',
      color: 'text-secondary'
    },
    {
      icon: Mountain,
      title: 'Mining & Resources',
      description: 'Comprehensive understanding of heavy-duty equipment fabrication and structural support for mining operations across South Africa\'s mining regions.',
      projects: 'Technical Proficiency',
      color: 'text-accent'
    },
    {
      icon: Building,
      title: 'Commercial Architecture',
      description: 'Skilled in architectural metalwork, decorative elements, and structural steel for commercial and residential buildings in major SA cities.',
      projects: 'Design Excellence',
      color: 'text-primary'
    }
  ];

  return (
    <section id="industries" className="py-20 lg:py-32 bg-background-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="fade-in text-center max-w-3xl mx-auto mb-16">
          <p className="text-sm font-bold text-secondary tracking-wider uppercase mb-4">Industries We Serve</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-primary mb-6">
            Versatile Capabilities Across Sectors
          </h2>
          <p className="text-lg text-foreground-muted">
            Our specialized fabrication knowledge serves diverse industries, each with unique requirements and exacting standards.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {industries.map((industry, index) => {
            const Icon = industry.icon;
            return (
              <Card
                key={index}
                className="fade-in group hover:shadow-elegant transition-all duration-300 border-border-light overflow-hidden"
              >
                <CardContent className="p-8">
                  <div className="flex items-start gap-6">
                    <div className="flex-shrink-0 w-16 h-16 rounded-xl bg-background-muted group-hover:bg-primary/10 flex items-center justify-center transition-colors duration-300">
                      <Icon className={`w-8 h-8 ${industry.color} group-hover:scale-110 transition-transform duration-300`} />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl sm:text-2xl font-serif font-bold text-primary mb-3 group-hover:text-secondary transition-colors">
                        {industry.title}
                      </h3>
                      <p className="text-foreground-muted leading-relaxed mb-4">
                        {industry.description}
                      </p>
                      <div className="inline-flex items-center px-4 py-2 bg-background-muted rounded-full">
                        <span className="text-sm font-semibold text-primary">{industry.projects}</span>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Background Image Section */}
        <div className="fade-in mt-16 max-w-6xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden shadow-elegant h-[300px]">
            <img
              src="https://images.unsplash.com/photo-1739599211500-74e04a9ca175?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzY5Njg5NTUyfDA&ixlib=rb-4.1.0&q=85"
              alt="Modern industrial facility"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary/60 via-primary/30 to-transparent"></div>
            <div className="absolute inset-0 flex items-center justify-center text-center px-4">
              <div>
                <p className="text-primary-foreground text-lg sm:text-xl font-medium mb-2">
                  Ready to Transform Your Vision?
                </p>
                <p className="text-primary-foreground/90 text-3xl sm:text-4xl font-serif font-bold">
                  Let's Build Something Exceptional
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesServed;
